import type { RiderSaleLineFormValues } from "./rider-sale-schema";

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}

export function calculateTotalSold(
  lines: { soldQty?: number }[] | undefined,
): number {
  return (lines ?? []).reduce((sum, l) => sum + Number(l.soldQty || 0), 0);
}

export function calculateTotalRemit(
  lines: { soldQty?: number }[] | undefined,
  sellingPrices: (number | null | undefined)[],
): number {
  return (lines ?? []).reduce(
    (sum, l, i) => sum + Number(l.soldQty || 0) * Number(sellingPrices[i] || 0),
    0,
  );
}

export function calculateTotalReturned(
  lines: { returnedQty?: number }[] | undefined,
): number {
  return (lines ?? []).reduce((sum, l) => sum + Number(l.returnedQty || 0), 0);
}

export function calculateTotalDiscrepancy(
  lines:
    | {
        dispatchedQty?: number;
        soldQty?: number;
        returnedQty?: number;
      }[]
    | undefined,
): number {
  return (lines ?? []).reduce((sum, l) => {
    const disp = Number(l.dispatchedQty || 0);
    const sold = Number(l.soldQty || 0);
    const ret = Number(l.returnedQty || 0);
    const diff = disp - sold - ret;
    return sum + (diff > 0 ? diff : 0);
  }, 0);
}

export function filterNonZeroLines(
  lines: RiderSaleLineFormValues[],
): RiderSaleLineFormValues[] {
  return lines.filter(
    (l) => l.dispatchedQty > 0 || l.soldQty > 0 || (l.returnedQty ?? 0) > 0,
  );
}
